import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjNavModule } from '@grapecity/wijmo.angular2.nav';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';

import {AppCommonsModule } from '../../../commons/app-commons.module';
import { FileUploadService } from '../../../commons/kymw02/file-upload/file-upload.service';
import { PlessSharedModule } from '../../../shared/pless-shared.module';

import { KYMW0A00Component } from './kymw0a00.component';
import { KYMW1900Module } from '../../../kymw/kymw19/kymw1900/kymw1900.module';
import { KYMW1901Module } from '../../../kymw/kymw19/kymw1901/kymw1901.module';
import { GetMembersVoiceSearchListService } from './api-services/get-members-voice-search-list.service';
import { GetMembersVoicePcodeListService } from './api-services/get-members-voice-pcode-list.service';
import { GetMembersVoiceDataService } from './api-services/get-members-voice-data.service';
import { GetPcodeList0AService } from './api-services/get-pcode-list-0a.service';
import { UpdateMembersVoiceDataService } from './api-services/update-members-voice-data.Service';
import { GetPublishVoiceHistory0AService } from './api-services/get-publish-voice-history-0a.service';
import { RegistPublishVoiceDataService } from './api-services/regist-publish-voice-data.service';
import { GetPublishVoiceDataService } from './api-services/get-publish-voice-data.service';
import { CheckNgWords0AService } from './api-services/check-ng-words-0a.service';
import { UploadMembersVoiceDataService } from './api-services/upload-members-voice-data.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';



/**
 * 組合員の声管理画面 モジュール設定クラス
 *
 * @export KYMW0A00Module
 * @class KYMW0A00Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjNavModule,
    WjInputModule,
    KYMW1900Module,
    KYMW1901Module,
    FontAwesomeModule
  ],
  declarations: [
    KYMW0A00Component,
  ],
  providers: [
    GetMembersVoiceSearchListService,
    GetMembersVoicePcodeListService,
    GetMembersVoiceDataService,
    GetPcodeList0AService,
    UpdateMembersVoiceDataService,
    GetPublishVoiceHistory0AService,
    RegistPublishVoiceDataService,
    GetPublishVoiceDataService,
    CheckNgWords0AService,
    UploadMembersVoiceDataService,
    FileUploadService,
  ],
})
export class KYMW0A00Module {
}
